export default {
    label: 'วิธีการชำระเงิน',
    methods: [
        'บัตรเครดิต/เดบิต',
        'ผ่อนชำระ',
        'พร้อมเพย์'
    ],
    pay: 'ชำระทันที',
    invoice: 'ใบแจ้งหนี้',
    receipt: 'ใบเสร็จรับเงิน',
    total: 'มูลค่าสุทธิ'
}
